import React, { Fragment } from "react";
import { statelookupjson } from "../../../data/schema/shared/StateLookup";
import "./style.scss";

const na_regex = /^[Nn]\/[Aa]$/;

const renderValues = (values) => {
  if (
    values &&
    typeof values === "object" &&
    !Array.isArray(values) &&
    values != null
  ) {
    return values["label"]; //return label for county objects
  } else if (values && values != null) {
    return values.map((val) => <span> {val.label} </span>); //for an array
  } else {
    return null;
  }
};

const addendumA9141CResolver = (machineName) => {
  const labels = {
    // worksiteAddr1: "Address 1",
    // worksiteAddr2: "Address 2",
    worksiteCity: "City",
    worksiteState: "State",
    worksiteCountyTownship: "County",
    worksitePostalCode: "Postal Code",
    // worksiteBlsAreaId: "Bls Area Id",
  };
  return labels[machineName];
};

const addendumCResolver = (machineName, formVersionId) => {
  const labels = {
    section_number: "Section of Material Term or Condition",
    section_name: "Summary of Material Term or Condition",
    section_details: "Details of Material Term or Condition",
  };
  // 790A V2
  if (formVersionId <= 2) {
    labels = {
      section_number:
        "Section/Item Number and Category of Material Term or Condition",
      section_name: "Summary of Material Term Condition",
      section_details: "Details of Material Term or Condition",
    };
  }
  return labels[machineName] || "Crop Info";
};

const addendumBC1Resolver = (machineName) => {
  const labels = {
    business_id: "skip",
    agricFein: "FEIN",
    agricLegalName: "Legal Business Name",
    agricTotalWorkers: "Total Workers",
    agricTradeName: "Trade Name / Doing Business As (DBA)",
    agricPrevTradeName1: "Previous DBA",
    agricPrevTradeName2: "Previous DBA",
    agricAddress1: "Address 1",
    agricAddress2: "Address 2 (suite/floor and number)",
    agricCity: "City",
    agricState: "State",
    agricPostalCode: "Postal Code",
    agricCounty: "County",
  };
  return labels[machineName];
};

const addendumBC2Resolver = (machineName, allValues) => {
  const labels = {
    legalName: "Name of Agricultural Business",
    agricFeinId: "skip",
    business_id: "skip",
    total_workers: "Total Workers",
    employment_address_1: "Employment Address",
    employment_city: "City",
    employment_county_id: "County",
    employment_state_id: "State",
    employment_zip: "Postal Code",
    begin_date: "First Date",
    end_date: "Last Date",
    additional_info: "Additional Place of Employment Information",
    isAdditionalActivity: "skip",
    crop_ids: "Crop and Agricultural Activity",
    additionalActivity:
      "Describe what specific services or labor is to be performed at this worksite.",
  };

  // This data is cleared only on submit based on this logic. So hide this from Review & Submit as well
  if (
    allValues?.prelim_5_is_livestock !== "YES" &&
    allValues?.appIsItinerant !== "YES" &&
    allValues?.prelim_2_employer_type !== "association-joint"
  ) {
    labels.begin_date = "skip";
    labels.end_date = "skip";
  }

  return labels[machineName];
};

const addendumBCResolverV2 = (machineName) => {
  const labels = {
    additional_info: "Additional Place of Employment Information",
    begin_date: "First Date",
    business_name: "Name of Agricultural Business*",
    employment_address_1: "Employment Address",
    employment_city: "City",
    employment_county_id: "County",
    employment_state_id: "State",
    employment_zip: "Postal Code",
    end_date: "Last Date",
    total_workers: "Total Workers",
  };
  return labels[machineName];
};

const addendumBDResolver = (machineName) => {
  const labels = {
    additional_info: "Additional Housing Information",
    housing_address_1: "Address/Location*",
    housing_city: "City",
    housing_county_id: "County",
    housing_state_id: "State",
    housing_type: "Type of Housing",
    housing_zip: "Postal Code",
    total_occ: "Total Occupancy",
    total_units: "Total Units",
    applicable_housing_standards_local: "Local Authority",
    applicable_housing_standards_state: "State Authority",
    applicable_housing_standards_swa: "SWA",
    applicable_housing_standards_federal: "Federal Authority",
    applicable_housing_standards_other_state: "Other State Authority",
    applicable_housing_standards_other: "Other (Specify)",
    applicable_housing_standards_other_text: "Specify:",
  };
  return labels[machineName] ? labels[machineName] : "skip";
};

const addendumAResolver = (machineName, formVersionId) => {
  const labels = {
    crop_id: "Crop ID",
    addmaCropState: "Work State",
    crop_name: "Crop or Agricultural Activity",
    wage_offer: "Wage Offer",
    wage_per: "Per",
    addmaPieceRate: "Piece Rate Offer",
    additional_info:
      "Piece Rate Units / Estimated Hourly Rate / Special Pay Information",
  };

  // 790A V2
  if (formVersionId <= 2) {
    labels = {
      additional_info: "Piece Rate Units/Special Pay Information",
      crop_id: "Crop ID",
      crop_name: "Crop or Agricultural Activity",
      wage_offer: "Wage Offer",
      wage_per: "Per",
    };
  }
  return labels[machineName] || "Crop Info";
};

const appendixAR9141Labels = {
  worksiteCity: "City",
  worksiteState: "State",
  worksiteCountyTownship: "County",
  worksiteBlsArea: "BLS Area",
};
const appendixALabels = {
  apdxaAddlInfo: "Additional Information",
  apdxaBeginDate: "Begin Date",
  apdxaCity: "City",
  apdxaCounty: "County",
  apdxaCrewId: "Crew ID",
  apdxaEndDate: "End Date",
  apdxaMsa: "MSA Name / OES Area Title",
  apdxaState: "State",
  apdxaTotalWorkers: "Total Workers",
  apdxaWageFrom: "Basic Wage Rate From",
  apdxaWagePer: "Per",
  apdxaWageTo: "Basic Wage Rate To",
};
const appendixC9142BLabels = {
  apdxcRecCity: "City",
  apdxcRecCountry: "Country",
  apdxcRecFirstname: "First (given) Name",
  apdxcRecLastname: "Recruiter's Last (family) Name",
  apdxcRecMiddlename: "Middle Name(s)",
  apdxcRecOrg: "Name of Employer/Recruiting Organization",
  apdxcRecProvince: "Province",
  apdxcRecState: "State",
  apdxcRecPostcode: "Postal Code",
};

const appendixB9142CLabels = {
  appx_b_city: "City",
  appx_b_state_id: "State",
  appx_b_zip: "Zip Code",
  appx_b_employment_info: "Additional Place of Employment Information",
  appx_b_crew_id: "Crew ID",
  appx_b_total_workers: "Total Workers",
  appx_b_begin_date: "Begin Date",
  appx_b_end_date: "End Date",
  appx_b_wage_from: "Basic Wage Rate (From)",
  appx_b_wage_to: "Basic Wage Rate (To)",
  appx_b_wage_freq: "Per",
};

const appendixAB9089Labels = {
  appAEduTypeId: "Education Type",
  appAEduOther: "Other Degree",
  appAEduMajors: "Major(s)",
  appAEduInstName: "Institution Name",
  appAEduCountryId: "Country of Institution",
  appAEduMonthYearAttained: "Month/Year Degree Attained",
};
const appendixAC9089Labels = {
  appATrainingInstName: "Training provider",
  appATrainingName: "Name of training/coursework",
  appATrainingCert: "Training/certifications/licenses Attained",
  appATrainingStartDate: "Training start date",
  appATrainingEndDate: "Training end date",
  appATrainingYearAwd: "Month/Year Awarded",
};
const appendixAD9089Labels = {
  appASkillsInstName: "Training provider",
  appASkillsCountryId: "Country",
  appASkillsStateId: "State/province/territory",
  fwTerritory: "State/province/territory",
  appASkillsSpecial: "Description of skills/proficiencies",
};
const appendixAE9089Labels = {
  appAExpEmpName: "Employer Name",
  appAExpAddress1: "Address 1",
  appAExpAddress2: "Address 2",
  appAExpCity: "City/town",
  appAExpPostalCode: "Postal Code",
  appAExpCountryId: "Country",
  appAExpStateTerritory: "State/province/territory",
  appAExpProvince: "State/province/territory",
  appAExpJobTitle: "Job Title",
  appAExpStartDate: "Start date",
  appAExpEndDate: "End date",
  appAExpFWPresent: "Present",
  appAExpWorkHour: "Hours worked per week",
  appAExpJobDuties: "Job duties",
};
const appendixC9089Labels = {
  sectionAndItemNum: "Section item number",
  sectionName: "Section name",
  suppInfo: "Supplementary information",
};
const appendixB9089Labels = {
  appx_b_city: "City",
  appBState: "State",
  appBCounty: "County",
  appBMsaName: "MSA title",
  appBMsaCode: "MSA code",
  appx_a_additional_info: "Additional info",
  appx_a_crew_id: "Crew ID",
  appx_a_total_workers: "Total workers",
  appx_a_begin_date: "Start date",
  appx_a_end_date: "End date",
  appx_a_wage_from: "From",
  appx_a_wage_to: "To",
  appx_a_wage_per: "Per",
};
const appendixC9142ALabels = {
  ownerRole: "Owner",
  operatorRole: "Operator",
  managerRole: "Manager",
  supervisorRole: "Supervisor",
  fein: "FEIN",
  otherFein: "Other FEIN",
  businessName: "Legal Business Name",
  otherBusinessName: "Other Legal Business Name",
  lastName: "Last Name",
  firstName: "First Name",
  middleName: "Middle Name",
  address1: "Address 1",
  address2: "Address 2",
  city: "City",
  state: "State",
  postalCode: "Postal Code",
  country: "Country",
  province: "Province",
  dob: "Date of Birth",
  phoneNumber: "Phone Number",
  phoneExt: "Phone Extension",
  email: "Email",
};
const appendixD9142ALabels = {
  lastName: "Last Name",
  firstName: "First Name",
  middleName: "Middle Name",
  recBusinessName: "Recruitment Org",
  city: "City",
  state: "State",
  postalCode: "Postal Code",
  country: "Country",
  province: "Province",
  registrationNumber1: "Registration Number 1",
  registrationNumberCountry1: "Issuing Country",
  registrationNumber2: "Registration Number 2",
  registrationNumberCountry2: "Issuing Country",
  registrationNumber3: "Registration Number 3",
  registrationNumberCountry3: "Issuing Country",
};

const appendixAB9089Resolver = (machineName) =>
  appendixAB9089Labels[machineName]
    ? appendixAB9089Labels[machineName]
    : "skip";
const appendixAC9089Resolver = (machineName) =>
  appendixAC9089Labels[machineName]
    ? appendixAC9089Labels[machineName]
    : "skip";
const appendixAD9089Resolver = (machineName) =>
  appendixAD9089Labels[machineName]
    ? appendixAD9089Labels[machineName]
    : "skip";
const appendixAE9089Resolver = (machineName) =>
  appendixAE9089Labels[machineName]
    ? appendixAE9089Labels[machineName]
    : "skip";
const appendixC9089Resolver = (machineName) =>
  appendixC9089Labels[machineName] ? appendixC9089Labels[machineName] : "skip";
const appendixB9089Resolver = (machineName) =>
  appendixB9089Labels[machineName] ? appendixB9089Labels[machineName] : "skip";

const appendixAR9141Resolver = (machineName) => {
  const labels = {
    ...appendixAR9141Labels,
  };
  return labels[machineName] ? labels[machineName] : "skip";
};
const appendixAResolver = (machineName) => {
  const labels = {
    ...appendixALabels,
  };
  return labels[machineName] ? labels[machineName] : "skip";
};

const appendixB9142CResolver = (machineName) => {
  const labels = {
    ...appendixB9142CLabels,
  };
  return labels[machineName] ? labels[machineName] : "skip";
};

const appendixC9142AResolver = (machineName) => {
  return appendixC9142ALabels[machineName]
    ? appendixC9142ALabels[machineName]
    : "skip";
};

const appendixD9142AResolver = (machineName) => {
  return appendixD9142ALabels[machineName]
    ? appendixD9142ALabels[machineName]
    : "skip";
};

const appendixCResolver = (machineName) => {
  const labels = {
    apdxcRecCity: "City",
    apdxcRecCountry: "Country",
    apdxcRecFirstname: "First (given) Name",
    apdxcRecLastname: "Recruiter's Last (family) Name",
    apdxcRecMiddlename: "Middle Name(s)",
    apdxcRecOrg: "Name of Employer/Recruiting Organization",
    apdxcRecProvince: "Province",
    apdxcRecState: "State",
    apdxcRecPostcode: "Postal Code",
  };
  return labels[machineName] || "Recruiter Info";
};

// get length of custom schema
const addendumLabelResolver = (addendumName) => {
  const labels = {
    "Appendix A - Multiple Worksites": appendixALabels,
    "Additional Worksites": appendixAR9141Labels,
    "Appendix C - Foreign Labor Recruiter Information": appendixC9142BLabels,
  };
  return labels[addendumName] ? Object.keys(labels[addendumName]) : undefined;
};
const cleanDate = (value) => {
  if (value) {
    let newDate = new Date(value);
    value = `${
      newDate.getMonth() + 1
    }/${newDate.getDate()}/${newDate.getFullYear()}`;
    return value;
  }
};

const cleanCrops = (value) => {
  if (value && Array.isArray(value)) {
    return value?.join(", ");
  }
  return value;
};

const cleanCounty = (value) => {
  if (value && value === "- Select -") {
    return "";
  }
  return value;
};

const cleanCheckbox = (value) => {
  if (value && Array.isArray(value)) {
    return value[0];
  }
  return value;
};
const appendixAValueUtils = (value) => {
  return {
    apdxaBeginDate: cleanDate,
    apdxaEndDate: cleanDate,
    apdxaCounty: cleanCounty,
  };
};

const appendixBValueUtils = (value) => {
  return {
    applicable_housing_standards_local: cleanCheckbox,
    applicable_housing_standards_state: cleanCheckbox,
    applicable_housing_standards_swa: cleanCheckbox,
    applicable_housing_standards_other_state: cleanCheckbox,
    applicable_housing_standards_federal: cleanCheckbox,
    applicable_housing_standards_other: cleanCheckbox,
  };
};

const appendixBValueUtils9142C = (value) => {
  return {
    appx_b_begin_date: cleanDate,
    appx_b_end_date: cleanDate,
    appx_a_county_id: cleanCounty,
  };
};

const addendumBC2ValueUtils = (value) => {
  return {
    begin_date: cleanDate,
    end_date: cleanDate,
    crop_ids: cleanCrops,
  };
};

const addendumBValueUtilsV2 = (value) => {
  return {
    begin_date: cleanDate,
    end_date: cleanDate,
  };
};

const appendixC9142AValueUtils = (value) => {
  return {
    ownerRole: cleanCheckbox,
    operatorRole: cleanCheckbox,
    managerRole: cleanCheckbox,
    supervisorRole: cleanCheckbox,
    dob: cleanDate,
  };
};

const addendumValueResolver = (addendumName, col, value, formVersionId) => {
  const helpers = {
    "Appendix A - Multiple Worksites": appendixAValueUtils(value),
    "Addendum B (C.2) - Additional Place of Employment Information":
      addendumBC2ValueUtils(value, formVersionId),
    "Addendum B - Additional Place of Employment Information":
      addendumBValueUtilsV2(value),
    "Addendum B - Additional <br/>Housing Location": appendixBValueUtils(value),
    "Appendix B - Additional Worksites": appendixBValueUtils9142C(value),
    "Additional Contact Information": appendixC9142AValueUtils(value),
  };
  if (helpers && helpers[addendumName] && helpers[addendumName][col]) {
    value = helpers[addendumName][col](value);
  }
  return value;
};
//function to get key of object
const getKeyByValue = (object, value, col) => {
  return col;
  // Object.keys(object).find(key => object[key] === value);
};

const AddedumResolver = (
  sectionName,
  machineName,
  allValues,
  formVersionId
) => {
  const addendumNames = {
    "Addendum A - Additional Crops and/or Agricultural Activities":
      addendumAResolver(machineName, formVersionId),
    "Addendum B (C.1) - Additional Agricultural Business Information":
      addendumBC1Resolver(machineName),
    "Addendum B (C.2) - Additional Place of Employment Information":
      addendumBC2Resolver(machineName, allValues),
    "Addendum B - Additional Place of Employment Information":
      addendumBCResolverV2(machineName),
    "Addendum B - Additional <br/>Housing Location":
      addendumBDResolver(machineName),
    "Addendum C - Material Terms<br/> and Conditions of the Job Offer":
      addendumCResolver(machineName, formVersionId),
    "Appendix A - Multiple Worksites": appendixAResolver(machineName),
    "Appendix C - Foreign Labor Recruiter Information":
      appendixCResolver(machineName),
    "Additional Worksites": appendixAR9141Resolver(machineName),
    "Additional  Worksites": addendumA9141CResolver(machineName),
    "Appendix A.B - Foreign Worker Education":
      appendixAB9089Resolver(machineName),
    "Appendix A.C - Foreign Worker Training Qualifications":
      appendixAC9089Resolver(machineName),
    "Appendix A.D - Foreign Worker Skills": appendixAD9089Resolver(machineName),
    "Appendix A.E - Foreign Worker Work Experience":
      appendixAE9089Resolver(machineName),
    "Appendix C - Supplemental Information": appendixC9089Resolver(machineName),
    "Appendix B - Additional Worksite Information":
      appendixB9089Resolver(machineName),
    "Addendum A - Other Worksites": addendumA9141CResolver(machineName),
    "Appendix B - Additional Worksites": appendixB9142CResolver(machineName),
    "Additional Contact Information": appendixC9142AResolver(machineName),
    "Foreign Labor Recruiter Information": appendixD9142AResolver(machineName),
  };
  return addendumNames[sectionName];
};

const renderRows = (addendum, formName, allValues) => {
  const formVersionId = allValues;
  if (addendum && addendum.value) {
    return addendum.value.map((row) => {
      return Object.keys(row)
        .filter((x) => {
          if (
            addendum &&
            addendum.page_title &&
            addendumLabelResolver(addendum.page_title)
          ) {
            let keys = addendumLabelResolver(addendum.page_title);
            return keys.includes(x);
          }
          return x !== "id";
        })
        .map((col, i) => {
          let value = row[col];
          let addendumName = addendum && addendum.page_title;
          let label = AddedumResolver(
            addendumName,
            getKeyByValue(row, value, col),
            allValues,
            formVersionId
          );

          if (label === "skip") {
            return null;
          }
          const customLength = addendumLabelResolver(addendumName);
          let rowLength;
          if (customLength) {
            rowLength = customLength.length;
          } else {
            rowLength = Object.keys(row).filter((x) => x !== "id").length;
          }
          if (
            value &&
            (col === "housing_state_id" || col === "employment_state_id")
          ) {
            let stateObj = statelookupjson.filter((state) => {
              return state.stateId === value;
            });
            if (stateObj && stateObj[0]) {
              value = stateObj[0].state;
            }
          }
          value = addendumValueResolver(
            addendumName,
            col,
            value,
            formVersionId
          );

          const showDivider =
            formName === "formUI9089" &&
            !!value &&
            typeof value === "string" &&
            (value === "None" || value.match(na_regex));

          return (
            <>
              {!!value && (
                <Fragment>
                  <div className="grid-row field-item">
                    <span className="grid-col-6 summary-label">{label}</span>
                    <span className="summary-answers grid-col-6">
                      {typeof value !== "object" ? value : renderValues(value)}
                    </span>
                  </div>
                </Fragment>
              )}
              {(i + 1) % rowLength === 0 || showDivider ? <hr /> : null}
            </>
          );
        });
    });
  }
};

const Addendum = ({ obj, formName, allValues }) => {
  return <div>{renderRows(obj, formName, allValues)}</div>;
};

export default Addendum;
